import { createFileRoute } from "@tanstack/react-router";
import HowTmsTherapyWorksCoralSpringsPage from "@/pages/articles/HowTmsTherapyWorksCoralSpringsPage";
export const Route = createFileRoute("/how-tms-therapy-works-coral-springs-fl")(
  {
    component: RouteComponent,
    head() {
      return {
        meta: [
          {
            title:
              "How TMS Therapy Works in Coral Springs, FL | Neuro Wellness",
          },
          {
            name: "description",
            content:
              "Discover how TMS therapy works at our Coral Springs, FL center—magnetic brain stimulation, session structure, neuroplasticity, and what to expect during.",
          },
          {
            property: "og:title",
            content:
              "How TMS Therapy Works in Coral Springs, FL | Neuro Wellness",
          },
          {
            property: "og:description",
            content:
              "Discover how TMS therapy works at our Coral Springs, FL center—magnetic brain stimulation, session structure, neuroplasticity, and what to expect during.",
          },
          {
            property: "og:url",
            content:
              "https://neurowellnesstms.com/how-tms-therapy-works-coral-springs-fl",
          },
          {
            property: "og:type",
            content: "website",
          },
          {
            name: "twitter:card",
            content: "summary_large_image",
          },
        ],
        links: [
          {
            rel: "canonical",
            href: "https://neurowellnesstms.com/how-tms-therapy-works-coral-springs-fl",
          },
        ],
      };
    },
  },
);
function RouteComponent() {
  return <HowTmsTherapyWorksCoralSpringsPage />;
}
